import { render, staticRenderFns } from "./statisticsMonth.vue?vue&type=template&id=35b12f85&"
import script from "./statisticsMonth.vue?vue&type=script&lang=js&"
export * from "./statisticsMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports